var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseSideBar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5313 11.5L22.9531 21.9219L21.9219 22.9531L11.5 12.5313L1.07814 22.9531L0.046875 21.9219L10.4687 11.5L0.0468771 1.07814L1.07814 0.046875L11.5 10.4687L21.9219 0.046875L22.9531 1.07814L12.5313 11.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseSideBar);
export default __webpack_public_path__ + "static/media/closeSideBar.fa68e1c64e22cb05594b43d94b84b0ab.svg";
export { ForwardRef as ReactComponent };